import { render } from "./account-opening-template.vue?vue&type=template&id=31736b07&lang=html"
import script from "./account-opening-template.vue?vue&type=script&lang=js"
export * from "./account-opening-template.vue?vue&type=script&lang=js"

import "./account-opening-template.vue?vue&type=style&index=0&id=31736b07&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__